
<br>

<div style="width: 100%;">
    <table mat-table matSort [dataSource]="dataSource" style="width: 100%;">
        <ng-container matColumnDef="date">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element">
                {{element.date| date:'MM/dd/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="time">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Time </th>
            <td mat-cell *matCellDef="let element">
                {{element.time| date:'hh:mm:ss'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="user">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> User </th>
            <td mat-cell *matCellDef="let element"> {{element.user}} </td>
        </ng-container>

        <ng-container matColumnDef="type">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="value">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Value </th>
            <td mat-cell *matCellDef="let element"> {{element.value}} </td>
        </ng-container>
        <ng-container matColumnDef="formervalue">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Former Value </th>
            <td mat-cell *matCellDef="let element"> {{element.formervalue}} </td>
        </ng-container>
        <ng-container matColumnDef="term">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Term </th>
            <td mat-cell *matCellDef="let element"> {{element.term}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>